// Import Dependencies
import React from 'react';

import Centering from '~/common/components/Centering';
import HeaderGroup from '~/common/components/HeaderGroup';
import { MARKETING_SITE_BASE_URL } from '~/common/utils/consts.js';

// Import Local Styles
import styles from '~/common/styles/block-view.css';
import btnStyles from '~/common/components/CommonButton/common-button.css';


const InternationalBlocker = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });

    return (
        <Centering relative={true}>
            <HeaderGroup modifiers={styles.header}>
                <h1>We’re sorry!</h1>
                <h2>Looks like Grasshopper is not available in your region.</h2>
            </HeaderGroup>
            <div className={styles.content}>
                <p>Currently Grasshopper is available only in the USA and Canada.</p>
                <p>We apologize for any inconvenience this may cause.</p>
            </div>
            <a className={`${btnStyles.button} ${styles.button}`} href={MARKETING_SITE_BASE_URL()}>Back to homepage</a>
        </Centering>
    );
};

export default InternationalBlocker;
